export default __webpack_public_path__ + "static/media/logoLine.606701bd.webp";